import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { BACKEND_API_URL } from "../../config";
// import { updateUserId } from "../FormNavigator/navigatorSlice";



export const fetchInitialState = createAsyncThunk(
  'ManagerData/fetch', 
  async (data, { getState, dispatch }) => {
    let unpreserved_state = {
        firstName: '',
        lastName: '',
        title: 'Producing Branch Manager',
        email: '',
        cellNumber: '',
        officeNumber: '',
        nmls: '',
        state: '',
        city: '',
    };
    const token = getState().navigator.token
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/manager?token=${token}`);
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const initialData = await response.json();        
        return initialData;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return unpreserved_state
      }
    
  })


const initialState = {
    data: {
        firstName: '',
        lastName: '',
        title: 'Producing Branch Manager',
        email: '',
        cellNumber: '',
        officeNumber: '',
        nmls: '',
        state: '',
        city: '',
    },
    status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
    loading: false,
    error: null,
    formErrors: {},
}

export const SubmitManagerDetails = createAsyncThunk(
    'ManagerData/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {
        
        // Perform client-side validation or dispatch another action to set validation state
        const { formErrors, data:_data } = getState().manager;
        const isFormValid = Object.values(formErrors).every((error) => error === '');
        if (!isFormValid) {
          // Handle validation errors
          return rejectWithValue("Please enter valid data in all the fields.");
        }

        const isFormDataValid = ['firstName', 'lastName' ,'title' ,'email' ,'cellNumber', 'state', 'city'].every(key => data[key])
        if (!isFormDataValid) {
          // Handle validation errors
          return rejectWithValue("Please fill the data in the required fields.");
        }
        if (_data.isOriginatingLoans && !data.nmls ) {
          // Handle validation errors
          return rejectWithValue("Please fill the data in the NMLS field.");
        }

        const currentStep = getState().navigator.currentStep;
        const token = getState().navigator.token;

        try {
            // Here you would send the form data to the server
            const response = await fetch(`${BACKEND_API_URL}/api/onboarding/manager?token=${token}`, {
                method: 'POST',
                body: JSON.stringify({'data': data, 'current_step': currentStep }),
                headers: {
                    'Content-Type': 'application/json',
                }
            });
  
            if (!response.ok) {
              // If the response is not 2xx, it is considered an error
              const errors = await response.json();
              Object.entries(errors).forEach(([field, error]) => {
                dispatch(setFieldError({ field, error }));
              });
              // console.log(errors);
              return rejectWithValue(errors);
            }
  
            const response_data =  await response.json();
            // Handle the response data
            // console.log('Form submitted successfully', response_data);
      
            // Return the response data for the fulfilled action
            // dispatch(updateUserId({ userId: response_data['id']}));
            return response_data;
          } catch (error) {
            // Handle submission errors
            console.error('Form submission error', error);
            // Throw an error for the rejected action
            return rejectWithValue(error);
          }

      }
)


export const managerDetailsSlice = createSlice({
    name: 'ManagerDetails',
    initialState,
    reducers: {
      setFormField: (state, action) => {
        const { field, value } = action.payload;
        state.data[field] = value;
      },
      setFieldError: (state, action) => {
        const { field, error } = action.payload;
        state.formErrors[field] = error;
      },
    },
    extraReducers: (builder) => {
        builder
          .addCase(SubmitManagerDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitManagerDetails.fulfilled, (state, action) => {
            state.loading = false;
          })
          .addCase(SubmitManagerDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          });
      },
  });


export const { setFormField, setFieldError } = managerDetailsSlice.actions;

export default managerDetailsSlice.reducer;
  